import { render, staticRenderFns } from "./detaliPageBottom.vue?vue&type=template&id=274a26c8&scoped=true"
import script from "./detaliPageBottom.vue?vue&type=script&lang=js"
export * from "./detaliPageBottom.vue?vue&type=script&lang=js"
import style0 from "./detaliPageBottom.vue?vue&type=style&index=0&id=274a26c8&prod&lang=scss&scoped=true"
import style1 from "./detaliPageBottom.vue?vue&type=style&index=1&id=274a26c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274a26c8",
  null
  
)

export default component.exports